import { useEffect, useRef } from "react";
import {
  loadHighcharts,
  type HighchartsChartOptions,
} from "./loadHighcharts";

export function HighchartsPanel({
  options,
  height = 320,
}: {
  options: HighchartsChartOptions;
  height?: number;
}) {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const optionsKey = JSON.stringify(options);

  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;

    let chart: { destroy: () => void } | null = null;
    let cancelled = false;
    const parsed = JSON.parse(optionsKey) as HighchartsChartOptions;

    void loadHighcharts().then((HC) => {
      if (cancelled || !containerRef.current) return;
      chart = HC.chart(containerRef.current, {
        credits: { enabled: false },
        ...parsed,
      });
    });

    return () => {
      cancelled = true;
      chart?.destroy();
    };
  }, [optionsKey]);

  return (
    <div
      ref={containerRef}
      className="admin-chart"
      style={{ width: "100%", height }}
    />
  );
}
